import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';
import * as moment from "moment";

@Component
class AttributeManagerComponent extends Vue {

  @Prop({ type: [String, Boolean, Number] })
  value: any;

  @Prop({ type: [Object] })
  attribute: {
    id: number,
    attribute_type: {
      id: number,
      calculable: boolean,
      name: string,
      type: string
    },
    fk_attribute_type: number,
    name: string,
    unit: string
  };

  @Prop({ type: [String] })
  label: string;

  dateMenu: boolean

  constructor () {
    super()
    this.dateMenu = false
  }

  get textConfigs () {
    return require('@/assets/json-resources/text-field-configs.json')
  }

  get computedDateFormattedMomentjs () {
    return this.vModel ? moment(this.vModel).format('DD/MM/YYYY') : ''
  }

  get coLabel () {
    return this.label || this.attribute.attribute_type.name
  }

  get vModel (): any {
    return this.value
  }
  set vModel (value: any) {
    this.$emit('input', value)
  }

  mounted () {
    moment.locale('fr')
  }
}

export default AttributeManagerComponent;



// WEBPACK FOOTER //
// ./src/components/attribute-manager/index.ts